import React from 'react';
import './CardsDashboard.css';
import waves from '../../../assets/waves.png';
import { useNavigate } from 'react-router-dom';
import UserCard from './UserCard'; // Import the new UserCard component
import './UserCard.css'; // Import the UserCard CSS

// `data` is the consolidated partner dashboard payload fetched once by Home.
const PartnerDashboard = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div className="partner-dashboard-wrapper">
      <UserCard
        user={data?.partner}
        onPartnerLogout={() => {
          localStorage.removeItem('partnerToken');
        }}
      />
      <div className="partner-dashboard dashboard-page">
        <div className="button-wrapper">
          <button
            className="edit-socials-btn"
            onClick={() => navigate('/edit-socials')}
            style={{ marginBottom: '1rem' }}
          >
            Edit Socials
          </button>
          <button
            className="edit-socials-btn"
            onClick={() => navigate('/tickets')}
            style={{ marginBottom: '1rem' }}
          >
            View Tickets
          </button>
        </div>
        <h1 className="dashboard-title">Analytics</h1>

        <div className="grid-container">
          {data && (
            <>
              {/* Total Videos Card */}
              <div
                className="card2"
                style={{
                  backgroundImage: `url(${waves})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                <div className="card-content">
                  <h4>Total Video Number</h4>
                  <p style={{ fontSize: 'clamp(24px, 5vw, 66px)', color: '#fff' }}>
                    {data.totalVideos}
                  </p>
                </div>
              </div>

              {/* Total Contact Us Clicks Card */}
              <div
                className="card2"
                style={{
                  backgroundImage: `url(${waves})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                <div className="card-content">
                  <h4>Total Contact Us Clicks</h4>
                  <p style={{ fontSize: 'clamp(24px, 5vw, 66px)', color: '#fff' }}>
                    {data.contactUsClicks ?? 0}
                  </p>
                </div>
              </div>

              {/* ← New Total QR Code Scans Card */}
              <div
                className="card2"
                style={{
                  backgroundImage: `url(${waves})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                <div className="card-content">
                  <h4>Total QR Code Scans</h4>
                  <p style={{ fontSize: 'clamp(24px, 5vw, 66px)', color: '#fff' }}>
                    {data.qrCodeClicks ?? 0}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PartnerDashboard;
